import React from 'react'
import { Col, Form } from 'react-bootstrap';

import { ContentRoute } from "../../../_metronic/layout";

import Module from "../../modules/Module";
import AppContext from '../../AppContext';

let yup = require('yup');

export default class Permission extends Module {
    info = Permission.Info;
    
    static Info = {
        "nameResource": "permissions",
        "icon": "fas fa-user-tag admin-menus-color",
        "path": "/permissions",
        "show": true
    };

    static get route() {
        return <ContentRoute key={this.Info.path} path={this.Info.path + "/:id?"} 
                component={(props) => <Permission match={props.match} location={props.location} history={props.history} />} />;
    }

    get title () {
        return AppContext.r["permission"];
    }

    get apiPath() {
        return '/permissions';
    }
    
    get schema () {
        return yup.object({
            title: yup.string().required()
        });
    }

    get tableHead () {
        return [{
            "Title": "Id",
            "Field": "id"
        },{
            "Title": AppContext.r["title"],
            "Field": "title",
            "ClassName": "min-width-200"
        }];
    }

    get initialValues() {
        return {
            title: "",
        };
    }

    get mask () {
        return ({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form onSubmit={handleSubmit}>
                <Form.Row>
                    <Col md="12">
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>{AppContext.r["title"]}*</Form.Label>
                                <Form.Control id="mainField" type="text" placeholder={AppContext.r["title"]} name="title"
                                                value={values.title} onChange={handleChange}
                                                isValid={touched.title && !errors.title} isInvalid={!!errors.title} 
                                                autoFocus />
                            </Form.Group>
                        </Form.Row>        
                    </Col>
                </Form.Row>
                
                {/* Shown only on editing */}
                <Form.Row style={this.displayOnEditStyle}>
                    <Form.Group as={Col}>
                        <p className="item-id-is-label">{AppContext.r["item-id-is"]} </p>
                        <Form.Control type="text" placeholder={AppContext.r["id"]} name="id" disabled className="item-id-is-control"
                                        value={values.id} />
                    </Form.Group>
                </Form.Row>

                {this.formFooter}
            </Form>);
    }
}